import React, { useState } from "react";
import { Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const statusColors = {
  active: "green",
  completed: "default",
  paused: "gold",
  failed: "red",
};

const ConversationsTable = ({ conversations }) => {
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const columns = [
    {
      title: "Target Name",
      dataIndex: "targetName",
      key: "targetName",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Campaign",
      dataIndex: "campaignName",
      key: "campaignName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={statusColors[status] || "default"}>
          {status ? status.charAt(0).toUpperCase() + status.slice(1) : "N/A"}
        </Tag>
      ),
    },
    {
      title: "Messages",
      dataIndex: "messageCount",
      key: "messageCount",
    },
    {
      title: "Extracted",
      dataIndex: "extractedCount",
      key: "extractedCount",
    },
    {
      title: "Last Activity",
      dataIndex: "lastMessageAt",
      key: "lastMessageAt",
      render: (date) =>
        date ? moment(date).format("MMM D, YYYY h:mm A") : "N/A",
    },
  ];

  const dataSource = (conversations || []).map((conv, index) => ({
    key: conv._id || index,
    _id: conv._id,
    targetName: conv.targetuserid?.name || conv.targetuserid?.Name || "Unknown",
    phone: conv.targetuserid?.phone || "N/A",
    campaignName: conv.campaignid?.name || "N/A",
    status: conv.status,
    messageCount: conv.messageCount || 0,
    extractedCount: conv.extractedData?.length || 0,
    lastMessageAt: conv.lastMessageAt,
  }));

  return (
    <Table
      className="table"
      dataSource={dataSource}
      columns={columns}
      onRow={(record) => ({
        onClick: () =>
          navigate(`/dashboard/conversations/${record._id}`),
      })}
      rowClassName="cursor-pointer hover:bg-gray-100 transition"
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: dataSource.length,
        onChange: (page, pageSize) => {
          setPagination({
            current: page,
            pageSize: pageSize,
          });
        },
      }}
    />
  );
};

export default ConversationsTable;
